
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { SquareLinkedService } from 'app/model/linkedservice/square.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'SquareObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Square_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Square_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SquareLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SquareObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
